"use strict";

import * as React from 'react';
export const BottomTabBarHeightContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=BottomTabBarHeightContext.js.map